import React, { useMemo } from "react";


export default (props) => {
  const imageForcolour = (c) => {
    if(c==='Base') return "Base";
    if(c==='Intermediate') return "Intermedio";
    if(c==='Advanced') return "Avanzato";
    if(c==='Admin') return "Amministratore";
  }

  const colour = useMemo(() => imageForcolour(props.value), [props.value]);
  console.log(colour);

  return (
    <div className="category-renderer">
        <span style={{width:"115px"}}>
         <div className={colour}>
           {colour}
         </div>
        </span>
    </div>
  );
};
